import React from 'react';
import { Modal } from './Modal';
import { AlertTriangle } from 'lucide-react';
interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  variant?: 'danger' | 'warning' | 'primary';
}
export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  variant = 'danger'
}: ConfirmDialogProps) {
  const getButtonClass = () => {
    switch (variant) {
      case 'danger':
        return 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500';
      case 'warning':
        return 'bg-amber-500 hover:bg-amber-600 text-white focus:ring-amber-500';
      default:
        return 'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500';
    }
  };
  const getIconClass = () => {
    switch (variant) {
      case 'danger':
        return 'text-red-600 bg-red-100';
      case 'warning':
        return 'text-amber-600 bg-amber-100';
      default:
        return 'text-blue-600 bg-blue-100';
    }
  };
  const footer = <>
      <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-442">
        Cancel
      </button>
      <button onClick={() => {
      onConfirm();
      onClose();
    }} className={`px-4 py-2 text-sm font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 ${getButtonClass()}`} data-id="element-443">
        {confirmLabel}
      </button>
    </>;
  return <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm" footer={footer} data-id="element-444">
      <div className="flex items-start gap-4" data-id="element-445">
        <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${getIconClass()}`} data-id="element-446">
          <AlertTriangle className="w-5 h-5" data-id="element-447" />
        </div>
        <div data-id="element-448">
          <p className="text-sm text-gray-600 mt-1" data-id="element-449">{message}</p>
        </div>
      </div>
    </Modal>;
}